/**
 * Résiliation — les dérivations pures du parcours.
 *
 * Rien ici ne connaît l'API : seulement les formes `UICancel*` et la règle que le legacy applique
 * déjà (`cancel-flow/screens/CancelReasonScreen.js:20-21`).
 */
import { type UICancelReason } from "../types/subscriptionCancel"

/**
 * L'étape « motif » est-elle complète ? Un motif choisi, et — quand ce motif demande une
 * précision — une précision non vide.
 *
 * La règle vit ici plutôt que dans la page : c'est elle qui décide si « Continuer » s'allume, et
 * c'est la seule chose que l'étape 1 calcule.
 */
export function canSubmitCancelReason(reasons: UICancelReason[], selectedKey: string | null, detail: string): boolean {
    if (selectedKey == null) return false
    const reason = reasons.find((r) => r.key === selectedKey)
    if (reason == null) return false
    return reason.requiresDetail !== true || detail.trim().length > 0
}
